import React from "react";
import Drawer from "@material-ui/core/Drawer";
import { makeStyles } from "@material-ui/core/styles";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";

import "./DrawerMui.css";

const useStyles = makeStyles({
  paper: {
    background: "#d8d8d8",
    color: "black",
    padding: "24px",
    width: "280px",
  },
  headerDrawer: {
    display: "flex",
  },
  icon: {
    margin: "auto",
    cursor: "pointer",
    width: "24px",
    height: "24px",
  },
});

const DrawerMui = (props) => {
  const { title, open, handleCloseDrawer } = props;
  const styles = useStyles();

  return (
    <Drawer anchor="left" open={open} classes={{ paper: styles.paper }}>
      <div className={styles.headerDrawer}>
        <span className="title">{title}</span>
        <CloseOutlinedIcon
          className={styles.icon}
          onClick={handleCloseDrawer}
        />
      </div>
      <div>{props.children}</div>
    </Drawer>
  );
};

export default DrawerMui;
